import { CheckIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { EstadoVerificacion } from '../../services/api';

export const PASOS_VERIFICACION = [
  { titulo: 'Fichas recibidas', norma: 'Recepción del papel' },
  { titulo: 'Cotejo integral', norma: 'Art. 3' },
  { titulo: 'Examen pericial', norma: 'Arts. 4 y 5' },
  { titulo: 'Sorteo', norma: 'Art. 6' },
  { titulo: 'Convocatoria', norma: 'Arts. 8 a 12' },
  { titulo: 'Clasificación y cómputo', norma: 'Arts. 13 y 14' },
  { titulo: 'Informe final', norma: 'Art. 15' },
] as const;

const PASO_POR_ESTADO: Partial<Record<EstadoVerificacion, number>> = {
  ABIERTA: 2,
  EN_COTEJO: 2,
  EN_EXAMEN_PERICIAL: 3,
  EN_SORTEO: 4,
  EN_VERIFICACION: 5,
  EN_SUBSANACION: 6,
  CERRADA: 8,
  ANULADA: 8,
};

export function pasoDeVerificacion(estado: EstadoVerificacion): number {
  return PASO_POR_ESTADO[estado] ?? 2;
}

interface Props {
  paso: number;
  alerta?: boolean;
  detalleActual?: string;
}

export default function PasosVerificacion({ paso, alerta = false, detalleActual }: Props) {
  return (
    <div className="overflow-x-auto">
      <ol className="grid min-w-[760px] grid-cols-7 gap-2">
        {PASOS_VERIFICACION.map((p, i) => {
          const n = i + 1;
          const hecho = n < paso;
          const actual = n === paso;
          return (
            <li key={p.titulo} className="flex flex-col gap-1.5" aria-current={actual ? 'step' : undefined}>
              <span className={`h-1.5 rounded-full ${
                hecho ? 'bg-primary-600'
                : actual ? (alerta ? 'bg-red-500' : 'bg-amber-500')
                : 'bg-gray-200'
              }`} />
              <span className={`flex items-center gap-1 text-sm ${
                hecho ? 'font-semibold text-gray-900'
                : actual ? 'font-bold text-gray-900'
                : 'font-medium text-gray-400'
              }`}>
                {hecho && <CheckIcon className="h-4 w-4 flex-shrink-0 text-primary-600" />}
                {actual && alerta && <ExclamationTriangleIcon className="h-4 w-4 flex-shrink-0 text-red-500" />}
                {p.titulo}
              </span>
              <span className={`text-xs ${actual ? (alerta ? 'text-red-700' : 'text-amber-700') : 'text-gray-500'}`}>
                {actual && detalleActual ? detalleActual : hecho ? `${p.norma} · hecho` : p.norma}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
